let hero_featured = document.getElementById('hero-featured');

if(hero_featured){
  window.onload = function() {
      document.getElementById('hero-featured').classList.add('move-img');
    };

}